<template>
  <div>
    <user-detail-title
        first-bread="用户管理"
        second-bread="用户管理查看"
        first-url="/user/manage"
        title-name="用户管理查看"
    />
    <user-detail-base>
      <el-form label-position="left" label-width="100px" v-if="LookData">
        <el-form-item label="ID" >
          <p>{{ LookData.id }}</p>
        </el-form-item>
        <el-form-item label="用户名">
          <p>{{ LookData.userName }}</p>
        </el-form-item>
        <el-form-item label="密码">
          <p>{{ LookData.password }}</p>
        </el-form-item>
        <el-form-item label="创建时间">
          <p>{{ LookData.createTime }}</p>
        </el-form-item>
        <el-form-item label="更新时间">
          <p>{{ LookData.updateTime }}</p>
        </el-form-item>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "@/views/User/Common/UserDetailTitle";
  import UserDetailBase from "@/views/User/Common/UserDetailBase";
  export default {
    name: "ManageLook",
    components: {UserDetailBase, UserDetailTitle},
    data(){
      return{
        LookData:null,
      }
    },
    created() {
      this.GetLookData(this.$route.params.id)
    },
    methods:{
      GetLookData(id){
        this.$axios.get('/api/user/getById',{params:{
            id:id
          }}).then(res=>{
          this.LookData=res.data.data
        })
      }
    }
  }
</script>

<style scoped>

</style>